import { useCallback, useEffect } from 'react';

export const useScroll = () => {
    const setScroll = useCallback(() => {
        document.body.style.setProperty(
            '--scroll',
            `${(window.scrollY / (window.document.documentElement.scrollHeight - window.innerHeight)) * 1000}`
        );
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', setScroll, false);

        return () => {
            document.body.style.setProperty('--scroll', `0`);
            window.removeEventListener('scroll', setScroll, false);
        };
    }, [setScroll]);
};
